import axios from 'axios';

export default async (props) => {
    const session = JSON.parse(window.localStorage.getItem('session'));
    const availableLanguages = process.env.REACT_APP_AVAILABLE_LANGUAGES.split(';');

    return axios({
        method: props.type,
        url: `${process.env.REACT_APP_WEBAPI_URL}/${props.method}`,
        data: props.params,
        timeout: props.timeout ? props.timeout : 60000,
        headers: {
            Authorization: session?.accessToken ? `Bearer ${session.accessToken}` : null,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization, Content-Length, X-Requested-With, Accept-Language',
            'accept': 'application/json',
            'Accept-Language': availableLanguages.length > 1 && localStorage.getItem('preferedLanguage') ? localStorage.getItem('preferedLanguage') : availableLanguages[0],
        }
    }).then((response) => {
        if (response && response.status >= 200 && response.status < 300) {
            return response.data;
        }
        return response;
    }).catch((err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem('session');
            // Only redirect when this was an established session (local JWT with name).
            // A temp Azure AD token ({ accessToken: azureToken }, no name) must not redirect —
            // that would loop: initialize() → AzureAuthenticate → 401 → redirect → initialize() → ...
            if (session?.name) {
                window.location.href = '/';
            }
        }
        return { error: true, status: err.response?.status, description: err.response?.data?.description ?? err.response?.data?.error ?? err.response?.data?.title ?? 'Erro desconhecido' };
    });
}
